import { Field, WrappedFieldsProps } from 'redux-form';
import { getProfileName } from '@mews-commander/legacy-entities/src/ducks/profiles';
import { useCommanderSelector } from '@mews-commander/utils';
import { DateTimeService, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { TextInput, TextInputProps } from '@optimus-web/core';

interface ActorTimestamp {
    profileId: string;
    utc: string;
}

interface ActorTimestampFieldProps extends Omit<TextInputProps, 'value' | 'readOnly' | 'disabled'> {
    value: ActorTimestamp;
}

const ActorTimestampInput = ({ value: { utc, profileId }, ...other }: ActorTimestampFieldProps) => {
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();
    const dateTimeLocalizedString = DateTimeService.toString(
        DateTimeService.fromUtcString(utc, timezone),
        localizationInfo
    );

    const profileName = useCommanderSelector((state) => getProfileName(state, { id: profileId }));
    const formattedProfileName = profileName ? ` (${profileName})` : '';

    const formattedValue = `${dateTimeLocalizedString}${formattedProfileName}`;

    return <TextInput {...other} name={other.name} value={formattedValue} readOnly disabled />;
};

const ActorTimestampFieldRenderer = ({
    input,
    meta: { error, ...otherMeta },
    ...other
}: ActorTimestampFieldProps & WrappedFieldsProps) => <ActorTimestampInput {...input} {...otherMeta} {...other} />;

export const ActorTimestampField = ({ name, ...props }: Omit<ActorTimestampFieldProps, 'value'>) => (
    <Field name={name} props={props} component={ActorTimestampFieldRenderer} />
);
